"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BatchInvoiceEditor = class BatchInvoiceEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getItemFromInvoices(...args) {
        const [invoices, fields] = args;
        const fieldNames = _.map(fields, 'name');
        let result = {};
        console.log('getItemFromInvoices', fieldNames, fields, invoices);
        _.each(invoices, (invoice, i) => {
            if (i === 0) {
                result = _.pick(invoice, fieldNames);
            }
            for (const { name, defaultValue } of fields) {
                if (result[name] != invoice[name]) {
                    result[name] = defaultValue;
                    continue;
                }
                if (_.isUndefined(result[name])) {
                    result[name] = defaultValue;
                    continue;
                }
                if (result[name] != null) {
                    result[name] = invoice[name];
                }
            }
        });
        result['$updates'] = _.reduce(fieldNames, (m, v) => _.set(m, v, false), {});
        console.log(result);
        return result;
    }
    getPayload(...args) {
        const [invoices, item] = args;
        const updates = _.keys(_.pickBy(item.$updates, _.identity));
        if (!updates.length) {
            return;
        }
        const update = _.pick(item, updates);
        return {
            items: _.map(invoices, invoice => ({
                id: invoice.id,
                etag: invoice.etag,
                value: update
            }))
        };
    }
    invoices;
    onInvoices(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoices");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    isReadonly;
    editableFields;
    labelAlign;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    item;
    async $$load_item() {
        return this.getItemFromInvoices(this.invoices, this.$data.editableFields);
    }
    currencies;
    async $$load_currencies() {
        return this.$app.repo.get('list_currency');
    }
    templates;
    async $$load_templates() {
        return this.$app.repo.get('list_template')
            .then(items => _.filter(items, { object_type: 'invoice_notification' }));
    }
    paymentMethods;
    async $$load_paymentMethods() {
        return this.$app.repo.get('list_payment_method')
            .then(data => _.reduce(data, (m, v, k) => _.set(m, v.id, this.$fn.pgettext('PaymentMethod', v.name))));
    }
    ux;
    b_7315092382398562_modalBindings;
    b_659581462804927_style;
    dataMembers = ['isReadonly', 'editableFields', 'labelAlign', 'formId', 'formName', 'item', 'currencies', 'templates', 'paymentMethods', 'ux', 'b_7315092382398562_modalBindings', 'b_659581462804927_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                isReadonly: false,
                editableFields: [{
                        name: "fulfillment_date",
                    },
                    {
                        name: "due_date",
                    },
                    {
                        name: "payment_method",
                    },
                    {
                        name: "currency",
                    },
                    {
                        name: "accounting_date",
                    },
                    {
                        name: "billing_period",
                        defaultValue: {
                            start: null,
                            end: null,
                        },
                    },
                    {
                        name: "email_template",
                    },
                    {
                        name: "notes",
                    },
                ],
                labelAlign: "right",
                formId: null,
                formName: "BatchInvoiceEdit",
                item: null,
                currencies: null,
                templates: null,
                paymentMethods: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
                b_659581462804927_style: {
                    width: "350px",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("BatchInvoiceEditor|Title", "Batch Edit Invoices"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3994_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_4000_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1040167445267876_request_3998_getActionArgs($event) {
        return {
            operation: "bulk_update_invoice",
            data: this.getPayload(this.invoices, this.item),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3994 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3994_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3993 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3994,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3993],
        });
        const act_2248226175642056_closeComponent_3996 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3995 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3996,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3995],
        });
        const act_1040167445267876_closeModal_4000 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_4000_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_3999 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_4000,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_3998 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_3998_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_3999],
        });
        const evh_1040167445267876_submit_3997 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_3998,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_3997],
        });
        const act_1419464017721962_closeComponent_4002 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_4001 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_4002,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_4001],
        });
        return {
            act_7315092382398562_closeModal_3994,
            evh_7315092382398562_close_3993,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3996,
            evh_2248226175642056_close_3995,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_4000,
            evh_1040167445267876_success_3999,
            act_1040167445267876_request_3998,
            evh_1040167445267876_submit_3997,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_4002,
            evh_1419464017721962_clickPreventStop_4001,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_request_3998,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Array,
    }),
    __metadata("design:type", typeof (_a = typeof array !== "undefined" && array) === "function" ? _a : Object)
], BatchInvoiceEditor.prototype, "invoices", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoices'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BatchInvoiceEditor.prototype, "onInvoices", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], BatchInvoiceEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BatchInvoiceEditor.prototype, "onSize", null);
BatchInvoiceEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], BatchInvoiceEditor);
exports.default = BatchInvoiceEditor;
vue_property_decorator_1.Vue.component("BatchInvoiceEditor", BatchInvoiceEditor);
